enum ENV_NAMES {
    DEV = 'dev',
    TEST = 'test',
    PREPROD = 'preprod',
    PROD = 'prod',
    WIREMOCK = 'wiremock',
}

export default ENV_NAMES;
